import { render } from "./TheFinalPrice.vue?vue&type=template&id=03894ec7&scoped=true&lang=html"
import script from "./TheFinalPrice.vue?vue&type=script&lang=js"
export * from "./TheFinalPrice.vue?vue&type=script&lang=js"

import "./TheFinalPrice.vue?vue&type=style&index=0&id=03894ec7&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03894ec7"]])

export default __exports__